import { validateSomething } from "../../Form/Validations";
import { toast } from "react-toastify";
import RestAPI from "@aws-amplify/api-rest";

export class AgViewer {

    /**
   * @returns {import("../types").DialogState}
  */
    static actionDialogState(t, data, i18n, unit) {
        return {
            visible: true,
            activeStep: 0,
            data: {},
            nombre_servicio: data.nombre_servicio,
            resolveBody: (values, props) => {
                const body = {
                    station_id: values.serial,
                    sensors: props?.dialogState?.data?.sensores_selected,
                    tipo: "AGVIEWER",
                    sectorName: values.sectorName,
                    nodeName: values.sectorName,
                    auth:props.dialogState.data.auth,
                    locale: i18n.language,
                };
                return { url: `/external/${props.farmId}`, body };
            },
            steps: [
                {
                    label: t("external.login"),
                    validateFunction: this.validateLogin,
                    inputs: [
                        {
                            label: t("external.username"),
                            campo: "username",
                            validation: validateSomething,
                            component: "text",
                        },
                        {
                            useCampo2: true,
                            label: t("external.password"),
                            campo: "password",
                            validation: validateSomething,
                            component: "text",
                            eyeForPassword: true,
                            type: "password"
                        },
                    ],
                },
                {
                    label: t("external.conectar"),
                    validateFunction: this.validateAg,
                    inputs: [
                        {
                            label: t("node.tipo.STATION_ONLY"),
                            campo: "serial",
                            validation: validateSomething,
                            component: "select",
                            optionsName: "agStations",
                            optionLabel: "name",
                            optionKey: "serial",
                            onChange: async (value, props, options) => {
                                props.setForceLoading(true);
                                const endpoint = `/external/${props.farmId}/agviewer-sensors`;
                                const body = {
                                    auth:props.dialogState.data.auth,
                                    station:value,
                                    locale: props.i18n.language
                                };
                                const agSensorsData = await RestAPI.post("apiAdminDropControl", endpoint, { body });
                                props.setForceLoading(false);
                                props.setFieldValue("sensors", agSensorsData.sensors);
                                props.setDialogState(s => ({
                                    ...s,
                                    data: {
                                        ...s.data,
                                        sensorTypes:agSensorsData.sensorTypes
                                    }
                                }));
                                const sectorName = options.find(o => o.serial === value)?.name ?? "";
                                props.setFieldValue("sectorName", sectorName);
                            }
                        },
                        {
                            label: t("external.sector-name"),
                            campo: "sectorName",
                            validation: validateSomething,
                            component: "text"
                        },
                        {
                            campo:"sensors",
                            campo2:"sensores_selected",
                            component: "tableAg",
                            validation:this.validateAg,
                            notInReview:true
                        },
                        {
                            campo:"sensors",
                            component: "tableAgRev"
                        },
                    ],
                },
            ],
        };
    }

    static validateAg = (values,props) => {
        const errors = {};
        if (values) {
            const errSens = values?.sensores_selected?.some(e => e.soil && e.depth===null);
            if(errSens)  errors.sensores_selected = "validation.sensor_depth";
            const errSer = validateSomething(values.serial);
            if (errSer !== undefined) errors.serial = errSer;

            const errSec = validateSomething(values.sectorName);
            if (errSec !== undefined) errors.sectorName = errSec;

            if(errors.username || errors.password || errors.sensores_selected) return errors;
            return errors;
        }
    };

    static async validateLogin(values, props) {
        const isSubmitting = props.innerRef.current.isSubmitting;
        const errors = {};
        try {
            if (values) {
                const errUser = validateSomething(values.username);
                if (errUser !== undefined) errors.username = errUser;

                const errPass = validateSomething(values.password);
                if (errPass !== undefined) errors.password = errPass;

                if(errors.username || errors.password) return errors;

                if (isSubmitting){
                    props.setForceLoading(true);

                    const endpoint = `/external/${props.farmId}/agviewer-credentials`;
                    const body = { auth:btoa(`${values.username}:${values.password}`), locale: props.i18n.language };
                    const agData = await RestAPI.post("apiAdminDropControl", endpoint, { body });

                    // set data that it will be used in the next step of the form
                    props.setDialogState(s => ({
                        ...s,
                        data: {
                            auth:btoa(`${values.username}:${values.password}`),
                            agStations: agData.stations,
                            sensorTypes: agData.sensorTypes,
                        }
                    }));

                    props.setForceLoading(false);
                }
                return errors;
            }
        } catch (error) {
            if (error.response?.status === 403){
                toast.error(props.t("forms.toast401"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                errors.unknown = props.t("forms.toast401");
            } else {
                toast.error(props.t("external.error-sign-in"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                errors.unknown = props.t("external.error-sign-in");
            }
            props.setForceLoading(false);
            return errors;
        }
    }
}
